import LessonScoreItem, { LessonScoreItemProps } from './LessonScoreItem';
export default LessonScoreItem;
export type { LessonScoreItemProps };
